import { useState } from 'react';
import { useDebounce } from '@/shared/hooks/useDebounce';

export interface UseClientsFiltersReturn {
  search: string;
  debouncedSearch: string;
  setSearch: (value: string) => void;
  activeFiltersCount: number;
  resetFilters: () => void;
}

export function useClientsFilters(): UseClientsFiltersReturn {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);

  const activeFiltersCount = (() => {
    let count = 0;
    if (search) count++;
    return count;
  })();

  const resetFilters = () => {
    setSearch('');
  };

  return {
    search,
    debouncedSearch,
    setSearch,
    activeFiltersCount,
    resetFilters,
  };
}
